import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { PageRequestParams } from '../../common/queryClient';
import {
  PageOfAnyRecordsSchema,
  type PageOfAnyRecordsType,
} from '../../common/utils/schema';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectUrl } from './DataObjectUrl';

interface ReportVersionDataParams extends PageRequestParams {
  dataObjectVersionId: number;
  filterParams: Record<string, string | number>;
}

const getReportVersionData = (params: ReportVersionDataParams) =>
  apiClient
    .get<PageOfAnyRecordsType>(expand(DataObjectUrl.REPORT, params))
    .then((response) => PageOfAnyRecordsSchema.parse(response.data));

export const useReportVersionDataQuery = createApiQueryHook(
  ['report-version-data'],
  getReportVersionData,
);
